<template>
  <el-cascader :options="allDepartList"
               :props="props"
               v-model="selectedOptions"
               @change="handleChange"
               placeholder="请选择机构"
               filterable change-on-select clearable>
  </el-cascader>
</template>
<script>
import { mapGetters } from 'vuex'; // allDepartList selectedOptions

export default {
  name: 'organizationalSelect',
  props: {
    selectedArr: {
      type: Array
    },
    selectType: {
      type: String,
      default: 'search'
    }
  },
  data() {
    return {
      props: {
        value: 'depCode',
        label: 'name',
        children: 'childRepDepConfigs'
      },
      selectedOptions: [],
      allDepartList: []
    };
  },
  computed: {
    ...mapGetters({
      userInfor: 'user/userInfor'
    })
  },
  created() {
    this.selectedOptions.push(this.userInfor.depCode);
  },
  methods: {
    handleChange(arr) {
      switch (arr.length) {
        case 0:
          this.getDepartList();
          break;
        default:
          this.getListAllChildDepAjax(arr);
          break;
      }
      this.$emit('handleChange', arr);
    },
    async getDepartList() {
      const { bean } = await this.$services.post({
        type: 'ORGANIZATIONALMANAGEMENT',
        url: 'getDepartList'
      });
      if (bean.length > 0) {
        bean.forEach(i => {
          i.childRepDepConfigs = [];
        });
      }
      this.allDepartList = bean;
      if (this.selectType !== 'search') {
        this.allDepartList.push({
          name: '暂无上级',
          depCode: '0'
        });
      }
    },
    getListAllChildDepAjax(arr) {
      if (arr[arr.length - 1] === null) {
        return;
      }
      if (arr[arr.length - 1] !== '0') {
        return new Promise(resolve => {
          this.$services.post({
            type: 'ORGANIZATIONALMANAGEMENT',
            url: 'getListAllChildDepAjax',
            params: { depCode: arr[arr.length - 1] }
          }).then(res => {
            if (res.code === '000') {
              let data = res.bean;
              if (data.length > 0) {
                data.forEach(i => {
                  i.childRepDepConfigs = [];
                });
              }
              switch (arr.length) {
                case 1:
                  this.allDepartList.forEach(item => {
                    if (item.depCode === arr[0]) {
                      if (data.length > 0) {
                        item.childRepDepConfigs = data;
                      }
                      else {
                        item.childRepDepConfigs = [{
                          name: '暂无下级',
                          depCode: null
                        }];
                      }
                    }
                  });
                  break;
                case 2:
                  this.allDepartList.forEach(item => {
                    if (item.depCode === arr[0]) {
                      item.childRepDepConfigs.forEach(aItem => {
                        if (aItem.depCode === arr[1]) {
                          if (data.length > 0) {
                            aItem.childRepDepConfigs = data;
                          }
                          else {
                            aItem.childRepDepConfigs = [{
                              name: '暂无下级',
                              depCode: null
                            }];
                          }
                        }
                      });
                    }
                  });
                  break;
                case 3:
                  this.allDepartList.forEach(item => {
                    if (item.depCode === arr[0]) {
                      item.childRepDepConfigs.forEach(aItem => {
                        if (aItem.depCode === arr[1]) {
                          aItem.childRepDepConfigs.forEach(bItem => {
                            if (bItem.depCode === arr[2]) {
                              if (data.length > 0) {
                                bItem.childRepDepConfigs = data;
                              }
                              else {
                                bItem.childRepDepConfigs = [{
                                  name: '暂无下级',
                                  depCode: null
                                }];
                              }
                            }
                          });
                        }
                      });
                    }
                  });
                  break;
                case 4:
                  this.allDepartList.forEach(item => {
                    if (item.depCode === arr[0]) {
                      item.childRepDepConfigs.forEach(aItem => {
                        if (aItem.depCode === arr[1]) {
                          aItem.childRepDepConfigs.forEach(bItem => {
                            if (bItem.depCode === arr[2]) {
                              bItem.childRepDepConfigs.forEach(cItem => {
                                if (cItem.depCode === arr[3]) {
                                  if (data.length > 0) {
                                    cItem.childRepDepConfigs = data;
                                  }
                                  else {
                                    cItem.childRepDepConfigs = [{
                                      name: '暂无下级',
                                      depCode: null
                                    }];
                                  }
                                }
                              });
                            }
                          });
                        }
                      });
                    }
                  });
                  break;
                case 5:
                  this.allDepartList.forEach(item => {
                    if (item.depCode === arr[0]) {
                      item.childRepDepConfigs.forEach(aItem => {
                        if (aItem.depCode === arr[1]) {
                          aItem.childRepDepConfigs.forEach(bItem => {
                            if (bItem.depCode === arr[2]) {
                              bItem.childRepDepConfigs.forEach(cItem => {
                                if (cItem.depCode === arr[3]) {
                                  cItem.childRepDepConfigs.forEach(dItem => {
                                    if (dItem.depCode === arr[4]) {
                                      if (data.length > 0) {
                                        dItem.childRepDepConfigs = data;
                                      }
                                      else {
                                        dItem.childRepDepConfigs = [{
                                          name: '暂无下级',
                                          depCode: null
                                        }];
                                      }
                                    }
                                  });
                                }
                              });
                            }
                          });
                        }
                      });
                    }
                  });
                  break;
                case 6:
                  this.allDepartList.forEach(item => {
                    if (item.depCode === arr[0]) {
                      item.childRepDepConfigs.forEach(aItem => {
                        if (aItem.depCode === arr[1]) {
                          aItem.childRepDepConfigs.forEach(bItem => {
                            if (bItem.depCode === arr[2]) {
                              bItem.childRepDepConfigs.forEach(cItem => {
                                if (cItem.depCode === arr[3]) {
                                  cItem.childRepDepConfigs.forEach(dItem => {
                                    if (dItem.depCode === arr[4]) {
                                      dItem.childRepDepConfigs.forEach(eItem => {
                                        if (eItem.depCode === arr[5]) {
                                          if (data.length > 0) {
                                            eItem.childRepDepConfigs = data;
                                          }
                                          else {
                                            eItem.childRepDepConfigs = [{
                                              name: '暂无下级',
                                              depCode: null
                                            }];
                                          }
                                        }
                                      });
                                    }
                                  });
                                }
                              });
                            }
                          });
                        }
                      });
                    }
                  });
                  break;
                default:
                  return 0;
              }
              resolve();
            }
          }).catch(() => {
          });
        });
      }
    }
  },
  mounted() {
    this.getDepartList();
    if (this.selectedArr[0] !== '0') {
      switch (this.selectedArr.length) {
        case 0:
          break;
        case 1:
          this.getListAllChildDepAjax([this.selectedArr[0]]).then();
          break;
        case 2:
          this.getListAllChildDepAjax([this.selectedArr[0]]).then(() => {
            setTimeout(() => {
              this.getListAllChildDepAjax([this.selectedArr[0], this.selectedArr[1]]).then();
            }, 50);
          });
          break;
        case 3:
          this.getListAllChildDepAjax([this.selectedArr[0]]).then(() => {
            setTimeout(() => {
              this.getListAllChildDepAjax([this.selectedArr[0], this.selectedArr[1]]).then(() => {
                this.getListAllChildDepAjax([this.selectedArr[0], this.selectedArr[1], this.selectedArr[2]]).then();
              });
            }, 50);
          });
          break;
        case 4:
          this.getListAllChildDepAjax([this.selectedArr[0]]).then(() => {
            setTimeout(() => {
              this.getListAllChildDepAjax([this.selectedArr[0], this.selectedArr[1]]).then(() => {
                this.getListAllChildDepAjax([this.selectedArr[0], this.selectedArr[1], this.selectedArr[2]]).then(() => {
                  this.getListAllChildDepAjax([this.selectedArr[0], this.selectedArr[1], this.selectedArr[2], this.selectedArr[3]]).then();
                });
              });
            }, 50);
          });
          break;
        case 5:
          this.getListAllChildDepAjax([this.selectedArr[0]]).then(() => {
            setTimeout(() => {
              this.getListAllChildDepAjax([this.selectedArr[0], this.selectedArr[1]]).then(() => {
                this.getListAllChildDepAjax([this.selectedArr[0], this.selectedArr[1], this.selectedArr[2]]).then(() => {
                  this.getListAllChildDepAjax([this.selectedArr[0], this.selectedArr[1], this.selectedArr[2], this.selectedArr[3]]).then(() => {
                    this.getListAllChildDepAjax([this.selectedArr[0], this.selectedArr[1], this.selectedArr[2], this.selectedArr[3], this.selectedArr[4]]).then();
                  });
                });
              });
            }, 50);
          });
          break;
        default:
          break;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.el-cascader {
  width: 100%;
}
</style>
